import {
    CheckRegular,
    ColumnRegular,
    DocumentRegular,
    DocumentTextRegular,
    MailRegular,
    PeopleLockRegular,
    PersonAddRegular,
    ToolboxRegular
} from '@fluentui/react-icons';
import type { AdminRouterItem } from '../router';
import RolePage from './components/role.tsx';
import Aufnahme from './sections/Aufnahme';
import BerichtAuswertungen from './sections/BerichtAuswertungen';
import Bewerbungen from './sections/Bewerbungen';
import Korrespondenz from './sections/Korrespondenz';
import TodoUpdates from './sections/TodoUpdates';
import Vorlagen from './sections/Vorlagen';
import Wartung from './sections/Wartung';

const dashboardRoutes: AdminRouterItem[] = [
    {
        path: '',
        element: <Bewerbungen />,
        meta: {
            label: "Bewerbungen",
            title: "Bewerbungen",
            key: "/",
            icon: <DocumentRegular />,
            allowedRoles: ['Admin', 'Read', 'Write'],
        }
    },
    {
        path: 'todo-updates',
        element: <TodoUpdates />,
        meta: {
            label: "Todo-Updates",
            title: "Todo-Updates",
            key: "/todo-updates",
            icon: <CheckRegular />,
            allowedRoles: ['Admin', 'Write'],
        }
    },
    {
        path: 'korrespondenz',
        element: <Korrespondenz />,
        meta: {
            label: "Korrespondenz",
            title: "Korrespondenz",
            key: "/korrespondenz",
            icon: <MailRegular />,
            allowedRoles: ['Admin', 'Write'],
        }
    },
    {
        path: 'bericht-auswertungen',
        element: <BerichtAuswertungen />,
        meta: {
            label: "Berichte/Auswertungen",
            title: "Berichte/Auswertungen",
            key: "/bericht-auswertungen",
            icon: <ColumnRegular />,
            allowedRoles: ['Admin', 'Read', 'Write'],
        }
    },
    {
        path: 'wartung',
        element: <Wartung />,
        meta: {
            label: "Wartung",
            title: "Wartung",
            key: "/wartung",
            icon: <ToolboxRegular />,
            allowedRoles: ['Admin', 'Write'],
        }
    },
    {
        path: 'aufnahme',
        element: <Aufnahme />,
        meta: {
            label: "Aufnahme",
            title: "Aufnahme",
            key: "/aufnahme",
            icon: <PersonAddRegular />,
            allowedRoles: ['Admin', 'Write'],
        }
    },
    {
        path: 'vorlagen',
        element: <Vorlagen />,
        meta: {
            label: "Vorlagen",
            title: "Vorlagen",
            key: "/vorlagen",
            icon: <DocumentTextRegular />,
            allowedRoles: ['Admin', 'Write'],
        }
    },
    {
        path: 'role',
        element: <RolePage />,
        meta: {
            label: "Rollenverwaltung",
            title: "Rollenverwaltung",
            key: "/role",
            icon: <PeopleLockRegular />,
            allowedRoles: ['Admin'],
        }
    }
];

export default dashboardRoutes
